import FeedSectionGroupTitle from './FeedSectionGroupTitle';
export default FeedSectionGroupTitle;
